<template>
  <div>
    <el-popover placement="bottom" width="50" trigger="hover" v-if="data.CanEdit">
      <div class="cs-courseware-action-buttonlist" v-loading="loading">
        <el-row>
          <span @click="onDownloadCoursewareClick()">下载</span>
        </el-row>
        <br />
        <el-row>
          <span @click="editCourseware()">编辑</span>
        </el-row>
        <br />
        <el-row>
          <span @click="deleteCourseware()">删除</span>
        </el-row>
      </div>
      <span slot="reference" style="border" class="cs-courseware-action">{{actions}}</span>
    </el-popover>
    <el-button class="cs-btn-download" type="primary" size="mini" @click="onDownloadCoursewareClick()" v-if="!data.CanEdit" :loading="loading">
      <img src="../../../assets/icon-download.png" />
      下载
    </el-button>
    <!-- <el-button
      class="cs-btn-download"
      type="primary"
      size="mini"
      @click="onDownloadCoursewareClick(true)"
      v-if="!data.CanEdit"
      :loading="loading"
    >
      <img src="../../../assets/icon-download.png" />
      下载(备用)
    </el-button> -->

    <studentQuestionnaireEditor v-if="USERMANAGER.isStudent" key="studentQuestionnaireEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)"
      @completed="onStudentQuestionnaireEditorCompleted" />
  </div>
</template>

<style lang="scss" scoped>
.cs-courseware-action {
  cursor: pointer;
}
.cs-courseware-action-buttonlist {
  text-align: center;
  margin: 0;
  span {
    margin-top: 30px;
    cursor: pointer;
  }
}
.cs-btn-download {
  img {
    height: 18px;
  }
}
@media screen and (max-width: 1030px) {
  .el-button + .el-button {
    margin-left: 0;
    margin-top: 5px;
  }
}
</style>

<script>
import {
  downloadCoursewareFile,
  getCoursewareFileUrl,
} from "../../../service/courseware.service";
import { downloadFile } from "../../../config/mUtils";
import { downloadFileWithName } from "@/service/blobStorage.service";

export default {
  props: {
    data: {},
  },
  data() {
    return {
      actions: "",
      loading: false,
    };
  },
  components: {
    studentQuestionnaireEditor: () =>
      import("@/components/questionnaire/studentQuestionnaireEditor"),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.actions = this.data.Actions;
    },
    editCourseware() {
      let data = {
        action: "editCourseware",
        data: this.data,
      };
      this.$emit("customEvent", data);
    },
    deleteCourseware() {
      let data = {
        action: "deleteCourseware",
        data: this.data,
      };
      this.$emit("customEvent", data);
    },
    onDownloadCoursewareClick() {
      if (this.USERMANAGER.isStudent) {
        if (this.data.IsFreeTrialOrReview){
          this.downloadCourseware();
        }else{
          this.openStudentQuestionnaireEditor();
        }
      } else {
        this.downloadCourseware();
      }
    },
    downloadCourseware() {
      if (!this.data.CanDownload) {
        let data = {
          action: "downloadCoursewareDisallow",
          data: this.data,
        };
        this.$emit("customEvent", data);
        return;
      }

      this.loading = true;
      let fileId = this.data.FileStorageId;
      if (this.data.IsDownloadFromAPI) {
        downloadCoursewareFile(fileId)
          .then((result) => {
            if (!!result && result.success) {
              downloadFile(result);
            } else {
              if (!!result.message) {
                this.$message.error(result.message);
              }
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (!!this.data.Url) {
        this.downloadFileByUrl(this.data.Url, this.data.FileName);
      } else {
        getCoursewareFileUrl(fileId)
          .then((result) => {
            if (!!result && result.success) {
              this.downloadFileByUrl(result.data.Url, result.data.FileName);
            } else {
              if (!!result.message) {
                this.$message.error(result.message);
              }
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    download(url, fileName) {
      var link = document.createElement("a");
      link.target = "_blank";
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    },
    downloadFileByUrl(url, fileName) {
      downloadFileWithName(url, fileName)
        .then((result) => {
          this.loading = false;
        })
        .catch(() => {
          setTimeout(() => {
            console.log("download from url", url);
            window.open(url, "_blank");
          });
          this.loading = false;
        });
    },
    openStudentQuestionnaireEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentQuestionnaireEditor"
      );
      if (!refEditor) return;

      refEditor.showDialog(this.USERMANAGER.studentId, this.data.CourseId);
    },
    onStudentQuestionnaireEditorCompleted() {
      this.downloadCourseware();
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/coursewareActionsCell.vue